type Unarray<T> = T extends (infer U)[] ? U : T;

export const STATE_LIST = [
  ["NSW", "New South Wales"],
  ["QLD", "Queensland"],
  ["SA", "South Australia"],
  ["TAS", "Tasmania"],
  ["VIC", "Victoria"],
  ["WA", "Western Australia"],
  ["Other", "Other"],
] as const;

export const STATE_LIST_KEYS = STATE_LIST.map((n) => n[0]);

export type StateKey = Unarray<typeof STATE_LIST_KEYS>;

export const TOTAL_MODULES = 4;
